// ModeSelector.js
import React, { useState } from "react";
import Matchmaking from "./Matchmaking";
import Rooms from "./Rooms";
import "./ModeSelector.css"; // Import CSS

export default function ModeSelector() {
  const [mode, setMode] = useState("matchmaking"); // default

  return (
    <div className="container">
      <div className="tabs">
        <button
          className={`tab ${mode === "matchmaking" ? "active" : ""}`}
          onClick={() => setMode("matchmaking")}
        >
          Matchmaking
        </button>
        <button
          className={`tab ${mode === "rooms" ? "active" : ""}`}
          onClick={() => setMode("rooms")}
        >
          Rooms
        </button>
        <div className={`slider ${mode}`} />
      </div>

      <div className="mode-content">
        {mode === "matchmaking" && <Matchmaking />}
        {mode === "rooms" && <Rooms />}
      </div>
    </div>
  );
}
